import { listMappings, listJobTitles, createMapping, deleteMapping } from '@/services/academy/insights.service'

export default {
	namespaced: true,
	state: {
		mappings:       { data: [], meta: { total: 0 } },
		mappingsStatus: 'init',
		jobTitles:      [],
		jobTitlesStatus:'init',
	},
	getters: {
		getMappings:        (s) => s.mappings,
		getMappingsStatus:  (s) => s.mappingsStatus,
		getJobTitles:       (s) => s.jobTitles,
		getJobTitlesStatus: (s) => s.jobTitlesStatus,
	},
	mutations: {
		SET_MAPPINGS(state, v)         { state.mappings = v },
		SET_MAPPINGS_STATUS(state, v)  { state.mappingsStatus = v },
		SET_JOB_TITLES(state, v)       { state.jobTitles = v },
		SET_JOB_TITLES_STATUS(state, v){ state.jobTitlesStatus = v },
	},
	actions: {
		async fetchMappings({ commit }, params) {
			commit('SET_MAPPINGS_STATUS', 'pending')
			try {
				const { data } = await listMappings(params)
				commit('SET_MAPPINGS', data)
				commit('SET_MAPPINGS_STATUS', 'init')
			} catch {
				commit('SET_MAPPINGS_STATUS', 'error')
			}
		},
		async fetchJobTitles({ commit }, params) {
			commit('SET_JOB_TITLES_STATUS', 'pending')
			try {
				const { data } = await listJobTitles(params)
				commit('SET_JOB_TITLES', data.data || [])
				commit('SET_JOB_TITLES_STATUS', 'init')
			} catch {
				commit('SET_JOB_TITLES_STATUS', 'error')
			}
		},
		async create({ dispatch }, payload) {
			await createMapping(payload)
			dispatch('fetchMappings')
		},
		async remove({ dispatch }, id) {
			await deleteMapping(id)
			dispatch('fetchMappings')
		},
	},
}
